// import node module libraries
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';

// import custom components
// import bootstrap icons
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import { useEffect, useState } from 'react';
import TypeLocalService from '../../services/TypeLocalService';
import LocalService from '../../services/LocalService';

const OffcanvasAddLocalForm = ({ onClick }) => {
	const [TypeLocalOptions, setTypeLocalOptions] = useState([]);
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');

	useEffect(() => {
		const fetchTypeLocalOptions = async () => {
			try {
				const TypeLocals = await TypeLocalService.getTypeLocalOptions();
				setTypeLocalOptions(TypeLocals);
			} catch (error) {
				console.error('Error fetching students options', error);
			}
		};

		fetchTypeLocalOptions();
	}, []);

	const status_CHOICES = [
		{ value: 'non_utilise', label: 'Non utilisé' },
		{ value: 'utilise', label: 'Utilisé' }
	];

	const TypeLocal_CHOICES = TypeLocalOptions;
	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const localData = new FormData();

				// Add all your form data to the FormData
				localData.append('nom', form.nom.value);
				localData.append('type', form.type.value);
				localData.append('status', form.status.value);
				localData.append('description', form.description.value);
				localData.append('capacite', form.capacite.value);
				localData.append('equipements', form.equipements.value);

				// Call the LocalService to create the Local
				const response = await LocalService.createLocal(localData);

				// Reset the form and state variables after successful creation
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Redirect the user to the list of Locals
				window.location.href = '/locaux/autres';
			} catch (error) {
				console.error('Erreur lors de la création du local', error);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<Form
			className="mb-3"
			noValidate
			validated={validated}
			onSubmit={handleSubmit}
		>
			{showAlert && (
				<Alert variant="danger">
					<ExclamationTriangleFill size={25} className="me-1" />
					{alertMessage}
				</Alert>
			)}
			<Row>
				<Col xs={12} className="mb-3">
					{/* Nom et type  */}
					<Form.Group>
						<Form.Label htmlFor="nom">
							Nom <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="nom"
							type="text"
							placeholder="Saisir le nom du Local"
							id="nom"
							required
							isInvalid={!!feedbackMessages['nom']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									nom: e.target.value ? '' : 'Le nom est requis.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['nom']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* status */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="status">
							Status <span className="text-danger">*</span>
						</Form.Label>
						<Form.Select
							name="status"
							required
							isInvalid={!!feedbackMessages['status']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									status: e.target.value
										? ''
										: 'Le status du Local est requise.'
								}));
							}}
						>
							{status_CHOICES.map((option, index) => (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['status']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* description */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="description">
							Description <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="description"
							as="textarea"
							placeholder="Saisir la description du Local"
							id="description"
							required
							isInvalid={!!feedbackMessages['description']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									description: e.target.value
										? ''
										: 'La description est requise.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['description']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				<Col xs={12} className="mb-3">
					{/* capacite et email  */}
					<Form.Group>
						<Row>
							<Col md={6} sm={12} className="mb-3">
								<Form.Label htmlFor="capacite">
									Capacite <span className="text-danger">*</span>
								</Form.Label>
								<Form.Control
									name="capacite"
									type="number"
									placeholder="Saisir la capacite du Local"
									id="capacite"
									required
									isInvalid={!!feedbackMessages['capacite']}
									onChange={(e) => {
										setFeedbackMessages((prevMessages) => ({
											...prevMessages,
											capacite: e.target.value ? '' : 'La capacite est requis.'
										}));
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['capacite']}
								</Form.Control.Feedback>
							</Col>
						</Row>
					</Form.Group>
				</Col>

				{/* equipements */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="equipements">Equipements</Form.Label>
						<Form.Control
							name="equipements"
							type="text"
							placeholder="Saisir l'equipements du Local"
							id="equipements"
							isInvalid={!!feedbackMessages['equipements']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									equipements: e.target.value ? '' : ''
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['equipements']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* type local */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="type">
							Type de local <span className="text-danger">*</span>
						</Form.Label>
						<Form.Select
							name="type"
							required
							isInvalid={!!feedbackMessages['type']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									type: e.target.value ? '' : 'Le type du Local  est requise.'
								}));
							}}
						>
							{TypeLocal_CHOICES.map((option, index) => (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['local']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* Buttons */}
				<Col xs={12} className="mt-4">
					<Button variant="success" type="submit">
						Enregistrer
					</Button>
					<Button onClick={onClick} variant="outline-danger" className="ms-2">
						Fermer
					</Button>
				</Col>
			</Row>
		</Form>
	);
};

export default OffcanvasAddLocalForm;
